import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';

import { getActiveProduct } from '../../../store/products/selectors';
import { selectEffectiveChannelState, selectEffectiveIsMasterView } from '../../../store/selectors/productSelectors';
import { productStateTabConstants } from '../constants/productStateTabConstants';
import ProductStateTabsBar from './ProductStateTabsBar';
import StagingTab from '../StagingTab';
import LiveTab from '../LiveTab';
import MasterTab from '../MasterTab';
import styles from './styles.module.scss';

const ProductStateTabs = ({ productId }) => {
  const location = useLocation();
  const { variantId } = useMemo(() => getActiveProduct(location), [location]);
  const { activeTab } = useSelector((state) => selectEffectiveChannelState(state, productId, variantId));
  const isMasterView = useSelector((state) => selectEffectiveIsMasterView(state, productId, variantId));

  return (
    <>
      <ProductStateTabsBar productId={productId} />
      <div className={cn('InfoPanelBody', styles.content)}>
        <Choose>
          <When condition={isMasterView}>
            <MasterTab />
          </When>
          <Otherwise>
            <Choose>
              <When condition={activeTab === productStateTabConstants.DRAFT}>
                <StagingTab />
              </When>
              <When condition={activeTab === productStateTabConstants.PUBLISHED}>
                <LiveTab />
              </When>
            </Choose>
          </Otherwise>
        </Choose>
      </div>
    </>
  );
};

ProductStateTabs.propTypes = {
  productId: PropTypes.string.isRequired,
};

export default ProductStateTabs;
